export * from './domain';
export * from './testkit';
export * from './builders';
export * from './dto';
export var createControlRoomApi = function (baseUrl, http) {
    var url = baseUrl + "/controlRoom";
    return {
        getAgentsTable: function (dto) { return http.post(url + "/dashboard", dto); },
        getAgentFullStats: function (agentId) { return http.get(url + "/" + agentId, {}); },
    };
};
//# sourceMappingURL=index.js.map